// extracted by mini-css-extract-plugin
export default {"documentWrapper":"EledoXfaEditor_documentWrapper__pscf7"};